import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import DropdownInputBorder from 'components/atoms/dropdownInputBorder';
import List from 'components/atoms/list';
import TimeFilter from 'components/templates/ccm/patientDetails/timeFilter';
import PatientAutocomplete from 'components/molecules/ccmAutocomplete';
import forms from 'constants/forms';
import useOutsideClick from 'utils/useOutsideClick';

const DEFAULT_FILTER = forms.patientFilterOptions[0];

const CcmPatientFilter = ({ handleSubmitTime, hideTimeFilter }) => {
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();

  const toggleFilter = () => {
    setIsOpen(!isOpen);
  };

  const ref = useRef();
  useOutsideClick(ref, () => {
    setIsOpen(false);
  });

  const onChange = (option) => {
    setFilter(option);
    toggleFilter();
  };

  const handleOnChange = (option) => {
    if (option) {
      const { value } = option;
      history.push(`/ccm/patient/${value}`);
    }
  };

  return (
    <div className="ccm-patient-filter">
      <Row>
        {!hideTimeFilter && (
          <Col xs="12" md="6" xl="4" className="ccm-patient-filter__item">
            <TimeFilter handleSubmit={handleSubmitTime} noUTC />
          </Col>
        )}
        <Col xs="12" md="6" xl="4" className="ccm-patient-filter__item">
          <div className="ccm-patient-filter__dropdown" ref={ref}>
            <DropdownInputBorder
              label="Patients List"
              value={filter?.label}
              handleClick={() => toggleFilter()}
            />
            {isOpen && (
              <div className="ccm-patient-filter__dropdown-body">
                <List
                  onChange={onChange}
                  options={forms.patientFilterOptions}
                />
              </div>
            )}
          </div>
        </Col>
        <Col xs="12" md="6" xl="4" className="ccm-patient-filter__item">
          {filter && !isOpen && (
            <div className="ccm-patient-filter__input">
              <PatientAutocomplete
                dropDownIcon={filter === DEFAULT_FILTER}
                filter={filter}
                onFilterChange={onChange}
                handleClick={handleOnChange}
                patient
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

CcmPatientFilter.propTypes = {
  hideTimeFilter: PropTypes.bool,
  handleSubmitTime: PropTypes.func,
};

export default CcmPatientFilter;
